// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + "views" + "." + "31945ae7cd69e3c3" + ".js";
};